
export const preferredCountries = ['us','in']
